<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Quote Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editQuote">Edit Quote</button>
                </div>
            </div>
            <div class="table-responsive" v-if="quote">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{quote.quoteId}}</td>
                    </tr>
                    <tr>
                        <th>Author</th>
                        <td>{{quote.author}}</td>
                    </tr>
                    <tr>
                        <th>Quote</th>
                        <td>{{quote.quote}}</td>
                    </tr>
                    <tr>
                      <th>Corporations</th>
                      <td>{{quote.csvCorporationName}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="quote.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewQuote',
        components: {
            LTable,
        },
        created (){
            console.log('inside view quote')
        this.$store.dispatch('GETSELECTEDQUOTE', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedQuote)
            this.quote = this.selectedQuote;
        })
    },
    data () {
        return {
          quote: {}
        }
    },
    methods: {
        editQuote(){
            this.$router.push({ name: 'EditQuote', params: { id: this.quote.quoteId}})
        },
    },
    computed: {...mapGetters([
        'selectedQuote'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Quotes/QuoteDetails.vue